import { useEffect, useState } from "react";

// Reveals `text` progressively for an "AI is writing" feel, but bounded to a target
// duration: the reveal step scales with length so a long summary finishes in about the
// same time as a short one instead of crawling out one character at a time.
export default function useTypewriter(text, { intervalMs = 16, durationMs = 1000, enabled = true } = {}) {
  const [displayed, setDisplayed] = useState(enabled ? "" : text);

  useEffect(() => {
    // Disabled: show the full text at once (no crawl). Used by the suggestion card, whose content must
    // appear complete alongside its reply — not type in a second stage after the card has landed.
    if (!enabled) {
      setDisplayed(text);
      return undefined;
    }
    if (!text) {
      setDisplayed("");
      return undefined;
    }
    setDisplayed("");
    const step = Math.max(1, Math.ceil(text.length / (durationMs / intervalMs)));
    let i = 0;
    const id = setInterval(() => {
      i += step;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, intervalMs);
    return () => clearInterval(id);
  }, [text, intervalMs, durationMs, enabled]);

  return enabled ? displayed : text;
}
